export const WORK_WITH_US_URL = "https://smartmarketeragency.typeform.com/apply";
export const MAIN_SITE_URL = "https://smartmarketeragency.com";

export const CLIENT_LOGOS = [
  { name: "Arrae", logo: "/assets/logos/arrae.png" },
  { name: "Clean-Eez", logo: "/assets/logos/clean-eez.webp" },
  { name: "Good Riddance", logo: "/assets/logos/good-riddance.webp" },
  { name: "Antler Rings", logo: "/assets/logos/antler-rings.webp" },
  { name: "Jamie Anne", logo: "/assets/logos/jamie-anne.webp" },
  { name: "Smart Earth", logo: "/assets/logos/smart-earth.webp" },
  { name: "ella+mila", logo: "/assets/logos/ella.png" },
  { name: "Big Life Journal", logo: "/assets/logos/big-life-journal.png" },
  { name: "Talking Point Cards", logo: "/assets/logos/tpc.png" },
  { name: "Crumbl", logo: "/assets/logos/crumbl.png" },
  { name: "Kajabi", logo: "/assets/logos/kajabi.png" },
  { name: "Shopify", logo: "/assets/logos/shopify.png" },
  { name: "Zipify", logo: null },
  { name: "BOOM by Cindy Joseph", logo: "/assets/logos/boom.png" },
  { name: "Overtone", logo: "/assets/logos/overtone.png" },
  { name: "Ink+Volt", logo: "/assets/logos/ink-volt.png" },
  { name: "Mind Journal", logo: "/assets/logos/mindjournal.png" },
  { name: "Nutripaw", logo: "/assets/logos/nutripaw-1.png" },
  { name: "Satchel", logo: "/assets/logos/satchel.png" },
  { name: "DLG", logo: "/assets/logos/DLG-gray-1.png" },
  { name: "Gabby", logo: "/assets/logos/gabby-gray.png" },
];

export const SOCIALS = [
  { name: "Facebook", url: "https://www.facebook.com/smartmarketeragency" },
  { name: "Instagram", url: "https://www.instagram.com/smartmarketeragency" },
  { name: "X", url: "https://x.com/smartmktagency" },
  { name: "YouTube", "url": "https://www.youtube.com/@smartmarketeragency" },
];
